// import HeaderHome from "./HeaderHome";
// import Newest from "./Newest";
import PopOver from "@/components/PopOver";
import { DeviceContext } from "@/context/device.context";
import { ProjectContext } from "@/context/project.context";
import { useAuth } from "@/hooks/useAuth";
import { exactCommentString } from "@/utils/html";
import EmojiData from "@emoji-mart/data";
import i18n from "@emoji-mart/data/i18n/vi.json";
import Picker from "@emoji-mart/react";

import { IReviewItem } from "Models";
import { Form } from "antd";
import clsx from "clsx";
import dynamic from "next/dynamic";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Mention, MentionsInput } from "react-mentions";
// import UploadReviewFile from "@/components/ReviewInputComponent.tsx/UploadReviewFile";

const UploadReviewFile = dynamic(
  import("@/components/ReviewInputComponent.tsx/UploadReviewFile"),
  { ssr: false }
);

const InputReplyReview = ({
  data,
}: // onCancelReview,
{
  data: IReviewItem;
  reviewItem: IReviewItem;
  onCancelReview?: () => void;
}) => {
  const form = Form.useFormInstance();
  const commentValue = Form.useWatch("comment", form);
  const { isMobile } = useContext(DeviceContext);

  const [focus, setFocus] = useState(false);
  const [poinerSelect, setPointerSelect] = useState<{
    selectionStart: number;
    selectionEnd: number;
  }>({
    selectionStart: 0,
    selectionEnd: 0,
  });

  const { loadingSendReply, setLoadingSendReply } = useContext(ProjectContext);

  const inputRef = useRef<any>(null);
  const { user } = useAuth();

  const metionsUser = {
    userId: data.createdBy._id,
    nickName: data.nickName || "",
  };
  // useEffect(() => {
  //   formRef.current.scrollIntoView(false);
  //   inputRef.current.focus();
  // }, []);
  useEffect(() => {
    form.setFieldsValue({
      nickName: user?.name,
      comment: `@{{${data.createdBy._id}||${
        data.nickName ? data.nickName : "anymos"
      }}} `,
    });
    inputRef.current?.inputElement?.focus();
  }, [data.createdBy, data.createdBy._id, data.nickName, form, user?.name]);
  // console.log(data, reviewItem);
  const replyLength = useMemo(() => {
    return commentValue
      ? exactCommentString(commentValue, [
          {
            userId: data.createdBy._id,
            nickName: data.nickName,
          },
        ])?.trim()?.length
      : 0;
  }, [commentValue, data.createdBy._id, data.nickName]);
  const fileList = Form.useWatch("file", form);

  return (
    <>
      <div
        className={clsx(
          "border px-[13px] pt-3 pb-1 rounded-md review-input duration-300 overflow-auto w-full",
          focus ? "ant-input ant-input-focused" : ""
          // hasError ? "border-red-500" : ""
        )}>
        <Form.Item
          name="comment"
          className="mb-0"
          rules={[
            {
              validator(rule, value, callback) {
                if (value?.trim()?.length || fileList?.length)
                  return Promise.resolve(true);
              },
            },
          ]}
          getValueFromEvent={(e) => {
            const txt = e.target.value;

            // console.log(txt.match(regex));
            const useTagString = metionsUser.nickName
              ? `@{{${metionsUser.userId}||${metionsUser.nickName}}}`
              : `@{{${metionsUser.userId}||anymos}}`;
            const userTagText = metionsUser.nickName
              ? `@${metionsUser.nickName}`
              : `@Ẩn danh`;
            let returnString = "";

            let fromindex = -1;
            do {
              const indexFind = txt.indexOf(useTagString, fromindex + 1);
              const realCurrentString = exactCommentString(returnString, [
                metionsUser,
              ]);

              if (indexFind >= 0) {
                if (
                  realCurrentString.length +
                    txt.slice(
                      fromindex === -1 ? 0 : fromindex + useTagString.length,
                      indexFind
                    ).length +
                    userTagText.length >=
                  2000
                ) {
                  returnString += txt.slice(
                    fromindex === -1 ? 0 : fromindex + useTagString.length,
                    indexFind - (fromindex + useTagString.length) >=
                      2000 - realCurrentString.length
                      ? fromindex +
                          useTagString.length +
                          2000 -
                          realCurrentString.length
                      : indexFind
                  );
                  break;
                } else {
                  returnString +=
                    txt.slice(
                      fromindex === -1 ? 0 : fromindex + useTagString.length,
                      indexFind
                    ) + useTagString;
                }
              } else {
                returnString += txt.slice(
                  fromindex === -1 ? 0 : fromindex + useTagString.length,
                  2000 -
                    realCurrentString.length +
                    fromindex +
                    useTagString.length
                );
              }

              fromindex = indexFind;
            } while (fromindex >= 0);

            return returnString;
          }}
          validateFirst>
          <MentionsInput
            spellCheck={false}
            ref={inputRef}
            onFocus={() => {
              setFocus(true);
            }}
            rows={3}
            onBlur={() => {
              if (inputRef.current)
                setPointerSelect({
                  selectionEnd: inputRef.current?.inputElement.selectionEnd,
                  selectionStart: inputRef.current?.inputElement.selectionStart,
                });
              setFocus(false);
            }}
            onPaste={() => {
              console.log("fsdfsdfh");
            }}
            placeholder="Nhập phản hồi"
            disabled={loadingSendReply}>
            <Mention
              style={{
                // color: "#3F82EE",
                backgroundColor: "#DCEBFB",

                // opacity: "100%",
                // position: "relative",
                // left: "-1px",
                // top: -1,
                // zIndex: 1,
              }}
              markup="@{{__id__||__display__}}"
              trigger={"@"}
              data={[
                {
                  id: data.createdBy._id,
                  display: data.nickName ? data.nickName : "anymos",
                },
              ]}
              displayTransform={(_id, display) => {
                // console.log(url);

                return `@${display === "anymos" ? "Ẩn danh" : display}`;
              }}
              renderSuggestion={(data) => (
                <div className="hidden">{data.display}</div>
              )}
            />
          </MentionsInput>
        </Form.Item>
        <Form.Item name={"file"} noStyle>
          <UploadReviewFile
            type="upload"
            setLoading={setLoadingSendReply}
            showPreview={false}
            loading={loadingSendReply}
          />
        </Form.Item>
        <Form.Item noStyle>
          <div className="flex justify-between items-center">
            <div className="flex">
              <div
                className="p-2 cursor-pointer text-grey-400"
                onClick={() => {
                  if (!loadingSendReply) {
                    document.getElementById("btn")?.click();
                  }
                }}>
                <i className="mrv mrv-attach_file text-fs-18"></i>
              </div>
              <div
                className="p-2 cursor-pointer text-grey-400"
                onClick={() => {
                  if (!loadingSendReply) {
                    document.getElementById("btn")?.click();
                  }
                }}>
                <i className="mrv mrv-add_photo_alternate text-fs-18 "></i>
              </div>

              {isMobile ? null : (
                <PopOver
                  position="left-top"
                  content={
                    <Picker
                      data={EmojiData}
                      onEmojiSelect={async (value) => {
                        const textarea = inputRef.current?.inputElement;
                        const mentionValue = data.nickName
                          ? `@{{${data.createdBy._id}||${data.nickName}}}`
                          : `@{{${data.createdBy._id}||anymos}}`;
                        const mentionShow = data.nickName
                          ? `@${data.nickName}`
                          : `@Ẩn danh`;
                        // const realValue = exactCommentString(
                        //   commentValue,
                        //   [
                        //     {
                        //       userId: data.createdBy._id,
                        //       nickName: data.nickName,
                        //     },
                        //   ]
                        // );
                        const index = commentValue.indexOf(mentionValue);
                        if (
                          (poinerSelect.selectionStart - index) *
                            (poinerSelect.selectionEnd *
                              (index + mentionValue.length)) <
                          0
                        )
                          return;
                        let start;
                        let end;
                        if (poinerSelect.selectionStart < index) {
                          start = commentValue.substring(
                            0,
                            poinerSelect.selectionStart
                          );
                          end = commentValue.substring(
                            poinerSelect.selectionEnd
                          );
                        } else {
                          start = commentValue.substring(
                            0,
                            poinerSelect.selectionStart +
                              mentionValue.length -
                              mentionShow.length
                          );
                          end = commentValue.substring(
                            poinerSelect.selectionEnd +
                              mentionValue.length -
                              mentionShow.length
                          );
                        }

                        const text = start + value.native + end;
                        if (
                          exactCommentString(text, [metionsUser]).length < 2000
                        ) {
                          form.setFieldValue("comment", text);
                          form.validateFields(["comment"]);
                          textarea.focus();
                          await Promise.resolve();
                          textarea.selectionStart = textarea.selectionEnd =
                            poinerSelect.selectionStart + value.native.length;
                        }
                      }}
                      i18n={i18n}
                    />
                  }
                  trigger={"click"}>
                  <button
                    className="p-2 cursor-pointer text-grey-400"
                    type="button"
                    id="btn-emoji"
                    disabled={loadingSendReply}>
                    <i className="mrv mrv-sentiment_very_satisfied text-fs-18 text-orange-400"></i>
                  </button>
                </PopOver>
              )}
            </div>

            <span className="text-[11px] text-grey-400">
              {replyLength} / 2000
            </span>

            {/* <EmojiPicker /> */}
          </div>
        </Form.Item>
        {/* {form.getFieldError(["comment"])} */}
      </div>
    </>
  );
};

export default InputReplyReview;
